import './main.less';
import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Field } from 'redux-form';

import InputField from '../../../shared/form-elements/input';
import ModalBox from '../../../shared/modal';

const Form = props => {
	return props.initialValues && (
		<div className="protection-edit__wrap">
			<form action="" className="ui-form" onSubmit={props.handleSubmit(data => props.protectionFormSubmit(data))}>
				<div className="ui-form__element">
					<strong>{props.initialValues.amount}</strong> - {props.initialValues.desc}
				</div>
				<div className="ui-form__element">
					<Field name="code" placeholder={props.intl('Protection code')} component={InputField} />
				</div>
				<div className="ui-form__element buttons-wrap">
					<button className="ui-btn ui-btn-primary">{props.intl('Confirm')}</button>
				</div>
			</form>
		</div>
	);
};

const Main = props => (
	<ModalBox
		title={props.intl('Finish protected transfer')}
		body={Form(props)}
		isOpen={props.shouldShowProtectionForm}
		onClose={props.toggleProtectionForm}
		className="create-protection-modal"
	/>
);

Form.propTypes = {
	intl: PropTypes.func,
	handleSubmit: PropTypes.func,
	protectionFormSubmit: PropTypes.func
};

Main.propTypes = {
	intl: PropTypes.func,
	shouldShowProtectionForm: PropTypes.bool,
	toggleProtectionForm: PropTypes.func
};

export default formName =>
	reduxForm({
		form: formName
	})(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/wm/components/protection-form/main.js